<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-alert-erro [alertErro]="alertErro" [mensagemErro]="mensagemErro" [tituloMensagemErro]="tituloMensagemErro" [botao2]="botao2" (alertErroFechou)="fecharAlertErro($event)"></app-alert-erro>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <form [formGroup]="formulario">
          <app-breadcrumb></app-breadcrumb>
          <h1 class="titulo">Contratar Recarga Certa</h1>
          <p class="paragrafo mb-4 mt-2">Contratação serviço recarga certa</p>

          <div class="row py-3 border-top border-bottom">
            <div class="col-6 col-lg-4">
              <span class="label">Razão Social</span>
              <p class="descricao mb-0">{{resources?.razaoSocial}}</p>
            </div>
            <div class="col-6 col-lg-4">
              <span class="label">CNPJ</span>
              <p class="descricao mb-0">{{resources?.cnpj}}</p>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-lg-4">
              <div class="mb-4">
                <label class="label-menor" for="slctAprovador">APROVADOR</label>
                <app-select
                  [form]="formulario"
                  name="idAprovador"
                  id="slctAprovador"
                  [options]="aprovadores"
                  optionValue="idContato"
                  defaultDescription="Selecione o Responsável"
                  optionText="nomeContato">
                </app-select>
              </div>
            </div>
            <!-- Texto descrição -->
            <div class="col-12">
              <p class="label">Caro Cliente </p>
              <p>
                A adesão do serviço Recarga Certa é SEM CUSTO. A Alelo descontará a taxa de {{taxa}} em cima da economia gerada.
                Caso não ocorra a economia não será cobrada nenhuma taxa, garantindo a eficiência do serviço.
              </p>
            </div>
            <!-- TERMO DE ADESÃO -->
            <div class="col-12 mt-3"><span class="label">{{ termo?.title}}</span></div>
          </div>

          <!-- Texto - TERMO DE ADESÃO -->
          <div class="row mx-1">
            <div class="col-12 border rounded p-4">
              <p class="descricao">{{ termo?.intro }}</p>

              <textarea class="text-area" rows="10" cols="140" id="detalhes" readonly
                [value]="termoTexto">
              </textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="checkTermosAdesao" formControlName="aceitarTermo">
                <label class="form-check-label" for="checkTermosAdesao">Li e concordo com o Termos de Adesão</label>
              </div>
            </div>

            <button class="botao mx-auto mt-4" id="btnContratar" (click)="onSubmit()" [ngClass]="{'disabled': !formulario.valid || !formulario.value.aceitarTermo }" [disabled]="!formulario.valid || !formulario.value.aceitarTermo" data-bs-toggle="tooltip" data-placement="top" title="Selecione o aprovador e aceite os termos.">CONTRATAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>

<!-- ALERT CONFIRMACAO -->
@if (showAlertConfirmacao) {
  <div class="body-alert">
    <div class="div-alert">
      <p class="titulo-alert">Confirmação de contrato</p>
      <div class="w-100 py-2 border-top border-bottom">
        <div class="row w-100 pt-3 ps-4">
          <div class="col-6">
            <span class="label">Razão Social</span>
            <p class="descricao">{{resources?.razaoSocial}}</p>
          </div>
          <div class="col-6">
            <span class="label">CNPJ</span>
            <p class="descricao">{{resources?.cnpj}}</p>
          </div>
        </div>
      </div>
      <h3 class="pergunta">Deseja confirmar a contratação do serviço Recarga Certa?</h3>
      <div class="footer-alert text-center">
        <button class="botao me-3" id="btnContratarModal" (click)='getContratar()'>CONTRATAR</button>
        <button class="botao-outline" id="btnCancelarModal" (click)="fecharAlertConfirmacao('cancelar')">CANCELAR</button>
      </div>
    </div>
  </div>
}
<!-- FIM ALERT CONFIRMACAO -->

<!-- INÍCIO ALERT SUCESSO -->
@if (showAlertSucesso) {
  <div class="body-alert">
    <div class="div-alert-sucesso text-center">
      <img src="/assets/img/success.png" width="70px" alt="">
      <h3 class="subtitulo-alert mt-3 mb-2">Contratação realizada</h3>
      <p class="paragrafo m-0">Serviço de Recarga Certa contratado com sucesso!</p>
      <button class="botao mt-4" id="btnFechar" (click)="fecharAlertSucesso()">FECHAR</button>
    </div>
  </div>
}
<!-- FIM ALERT SUCESSO -->




<app-footer></app-footer>
